import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledCurrentLocation = styled.div`
  ${rtl`
  margin: 0;
  @media ${theme.mediaQuery.tablet} {
    margin: 0 0 ${toRem(28)};
    border-color: ${theme.color['gallery']};
  }
  @media ${theme.mediaQuery.desktop} {
    margin: 0 ${toRem(32)} ${toRem(24)};
    border-bottom: none;
  }
  @media ${theme.mediaQuery.largeDesktop} {
    margin: 0 0 ${toRem(24)};
    border-bottom: none;
  }
  a {
    position: relative;
    padding: ${toRem(12)} ${toRem(24)} ${toRem(12)} ${toRem(40)};
    margin: ${toRem(12)} ${toRem(-16)};
    @media ${theme.mediaQuery.tablet} {
      padding-left: ${toRem(80)};
      margin: ${toRem(12)} ${toRem(-24)};
    }
    @media ${theme.mediaQuery.desktop} {
      padding: ${toRem(14)} 0 ${toRem(14)} ${toRem(54)};
      margin: 0;
    }
    @media ${theme.mediaQuery.largeDesktop} {
      padding:${toRem(14)} 0 ${toRem(14)} ${toRem(54)};
      margin: 0;
    }
    @media ${theme.mediaQuery.mobileOnly} {
      padding-top: ${toRem(24)};
      padding-bottom: ${toRem(12)};
      margin-top: 0;
      left: ${toRem(15)};
    }
    display: block;
    text-decoration: none;
    [class^='icon-']::before {
      width: ${toRem(16)};
      height: ${toRem(16)};
      color: ${theme.color['light-orange-2']};
      position: absolute;
      left: ${toRem(-24)};
      @media ${theme.mediaQuery.tablet} {
        left: ${toRem(-32)};
      }
    }
    [class^='icon-'] {
      color: ${theme.color['dark-gray-1']};
    }
    span {
      position: relative;
    }
    :hover,
    :focus {
      background-color: ${theme.color['light-gray-3']};
      font-weight: ${theme.fonts['fontWeightMedium']};
    }
  }
`}
`;
